module.exports = __webpack_public_path__ + "img/Marca20.46cf3395.jpg";